export default "__VITE_PUBLIC_ASSET__c6860f3f__"